import angular from "angular";
import angularUIB from "angular-ui-bootstrap";

let mod = angular
    .module('ErrorProcessing.form', [angularUIB])
    .component('errorProcessingForm', {
        template: require('./error-processing-form.component.html'),
        controller: ['$http', '$window', 'notifier', Controller],
        bindings: {
            params: '<'
        }
    });

function Controller ($http, $window, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.baseUrl = '/control-panel/error-processing';

        $ctrl.entityTypes = [
            {key: 'avia', name: 'Авиа'},
        ];
        $ctrl.providers = {
            avia: [
                {key: 'amadeus', name: 'Амадеус'},
                // {key: 'vip_air', name: 'ВИП эир'},
                // {key: 'qazaq_air', name: 'Qazaq эир'},
                {key: 'fly_arystan', name: 'Fly Arystan'},
            ],
        };
        $ctrl.errorTypes = [
            {key: 'request', name: 'Ошибка запроса'},
            {key: 'response', name: 'Ошибка в ответе'}
        ];

        $ctrl.form = {
            id: $ctrl.params.id,
            entity_type: $ctrl.params.entity_type,
            provider: $ctrl.params.provider,
            http_code: $ctrl.params.http_code,
            error_type: $ctrl.params.error_type,
            error_code: $ctrl.params.error_code,
            condition_message: $ctrl.params.condition_message,
            allow_not_equals: $ctrl.params.allow_not_equals,
            message: $ctrl.params.message,
            response_code: $ctrl.params.response_code || 400,
            active: $ctrl.params.id ? $ctrl.params.active : 1,
            send_mail: $ctrl.params.send_mail,
            is_critical: $ctrl.params.is_critical
        };
    };

    $ctrl.submitForm = function () {
        $http(formParams()).then(function (response) {
            notifier.successNotify('Данные успешно сохранены');
            $window.location.href = $ctrl.baseUrl + '/' + response.data.id + '/edit';
        }, notifier.errorResponseNotify);
    };

    $ctrl.changeEntityType = function () {
        $ctrl.form.provider = null;
    };

    function formParams() {
        let params = {
            url: $ctrl.baseUrl,
            method: 'post',
            data: $ctrl.form
        };

        if ($ctrl.form.id) {
            params.url = $ctrl.baseUrl + '/' + $ctrl.form.id;
            params.method = 'put';
        }

        return params;
    }
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/error-processing/form/error-processing-form.component.js